










import { Component, Vue } from 'vue-property-decorator';

import SummaryContainer from '../components/SummaryContainer.vue';
import { AssessmentInstance } from '../models';
import { httpGet } from '../utils';

@Component({
  components: {
    SummaryContainer,
  },
})
export default class SummaryView extends Vue {
  private isLoading: boolean = true;
  private isError: boolean = false;
  private errorMessage: string = '';
  private assessment: AssessmentInstance | null = null;

  private created() {
    this.isLoading = true;
    const url = `${process.env.VUE_APP_API_HOST}/assessments/${this.$route.params.assessmentId}/full`;
    httpGet<AssessmentInstance>(url)
      .then((assessment) => {
        this.assessment = assessment;
      }).catch((error) => {
        this.errorMessage = error.message;
        this.isError = true;
      }).then(() => {
        this.isLoading = false;
      });
  }
}
